module.exports = __webpack_public_path__ + "../assets/img/63ff02b57ce311f113fc024ddde6f7a1.svg";